import { z } from 'zod'

export const ActiveCampaignItemSchema = z.object({
  stringid: z.string(),
  name: z.string(),
  id: z.number(),
  isDefault: z.boolean(),
})

export const ActiveCampaignFieldSchema = z.object({
  type: z.string(),
  name: z.string(),
  id: z.string(),
  isAvailable: z.boolean(),
})

export const ActiveCampaignListSchema = z.object({
  lists: z.array(ActiveCampaignItemSchema).or(z.array(z.void())),
})
export const ActiveCampaignFieldsSchema = z.object({
  fields: z.array(ActiveCampaignFieldSchema).or(z.array(z.void())),
})

export type ModifiedActiveCampaignField = (ActiveCampaignField & { label: string }) | void
export type ActiveCampaignField = z.infer<typeof ActiveCampaignFieldSchema>
